<template>
    <div>
        <div class="infoChoose-header">
            <div class="infoChoose-blue-tab">
                <img src="./../../assets/images/logo.png" alt="安盾网">
            </div>
            <h2 class="infoChoose-title" ref="subTitle">完善资料</h2>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
    props: [''],
    methods: {},
    created(){},
    beforeMount(){},
    mounted(){
        if(this.$route.path=='/changeInfo'){
            this.$refs.subTitle.innerHTML = '修改资料';
        }
    },
    updated(){},
    components: {},
    watch: {}
}
</script>
<style scoped lang="sass">
@import "./perfectInfo.scss"
</style>



// WEBPACK FOOTER //
// src/view/perfectInfo/perfectInfo.vue